import { isAuth } from "@/utils/api";
import { ADMIN_REFRESH_TOKEN_KEY } from "@/utils/constants";
import { getLastAuthRoute } from "@/utils/lastAuthRoute";
import { getSafeRedirectURL } from "@/utils/url";
import Cookies from "js-cookie";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

/**
 * Guards guest-only routes (login, recover). A visitor that still holds a usable
 * session — a valid access token, or a refresh token `withAuth` can trade for one —
 * is sent back to where they came from (`?redirectUrl`), then to the last
 * authenticated route, then home.
 */
export const guestLoader = ({ request }: LoaderFunctionArgs) => {
  if (isAuth() || Cookies.get(ADMIN_REFRESH_TOKEN_KEY)) {
    const redirectUrl = new URL(request.url).searchParams.get("redirectUrl");
    const fallback = getSafeRedirectURL(getLastAuthRoute());
    return redirect(getSafeRedirectURL(redirectUrl, fallback));
  }
  return null;
};
